import { makeStyles } from "@mui/styles"
import { Theme } from "@mui/material"
import Colors from "../Colors"
import { dimensions, fontSizes } from "../Dimens"
import "@fontsource/nunito-sans"

export const styles = makeStyles((theme: Theme) => {
  return {
    justifySpaceBetween: {
      justifyContent: "space-between",
      alignItems: "center",
      display: "flex",
    },
    alignBaseLine: {
      alignItems: "baseline",
    },
    textCenter: {
      textAlign: "center",
    },
    imageSize: {
      height: "28px",
      width: "28px",
    },
    inputLabel: {
      // textAlign: 'left',
      color: Colors.white,
    },
    width80: {
      width: "80%",
    },
    width60: {
      width: "60%",
    },
    width40: {
      width: "40%",
    },
    fullWidth: {
      width: "100%",
    },
    width90: {
      left: "0px",
      right: "0px",
    },
    width37: {
      width: "37%",
    },
    width50: {
      width: "50%",
    },
    mt2: {},
    mt3: {},
    mt1: {
      // marginLeft: theme.spacing(32),
    },
    mr2: {},
    mr5: {},
    ml2: {},
    ml1: {},
    ml0: {},
    mb3: {},
    mb1: {},
    mlr10: {},
    floatRight: {
      float: "right",
    },
    errorMsg: {
      fontSize: `${fontSizes.sm} !important`,
      textAlign: "left",
      color: `${Colors.red} !important`,
    },
    copyright: {
      color: Colors.lightYellow,
      textDecoration: "none",
    },
    pad20: {
      // padding: "24px",
    },
    pr30: {},
    flexColumn: {
      display: "flex",
      flexDirection: "column",
    },
    flexRow: {
      display: "flex",
      flexDirection: "row",
    },
    flexColumnRight: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
    },
    flexRowRight: {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-end",
      justifyContent: "flex-end",
    },
    flexColumnLeft: {
      display: "flex",
      flexDirection: "column",
      alignItems: "left",
    },
    flex: {
      display: "flex",
    },
    flex1: {
      flex: 1,
    },
    relative: {
      position: "relative",
    },
    flexCenter: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    flexColumnCenter: {
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "center",
      flexDirection: "column",
    },
    alignItemsCenter: {
      alignItems: "center",
    },
    fullHeight: {
      height: "100%",
    },
    mtb5: {},
    mtb6: {},
    marginFix: {
      marginTop: "10px",
      marginBottom: "10px",
    },
    activityBox: {
      width: "90px",
      height: "90px",
      padding: "10px",
      margin: "10px",
      background: "#181536 0% 0% no-repeat padding-box",
      borderRadius: "10px",
      textAlign: "center",
      opacity: 1,
    },
    channelbox: {
      display: "flex",
      justifyContent: "space-between",
      textAlign: "left",
      color: Colors.white,
    },
    channelbox2: {
      textAlign: "center",
      color: Colors.white,
      padding: "10x",
      top: 0,
      bottom: 0,
    },
    gradients: {
      color: Colors.btnBg,
    },
    ur2: {
      top: "326px",
      left: "883px",
      width: "36px",
      height: "21px",
    },
    accountBackground: {
      background: "#251F4D 0% 0% no-repeat padding-box",
      borderRadius: "10px",
      padding: "5px",
      display: "flex",
    },
    uploads: {
      display: "flex",
    },
    streamBackground: {
      background: "#181536 0% 0% no-repeat padding-box",
      borderRadius: "10px",
      padding: "10px",
    },
    margins: {
      display: "flex",
      alignItems: "center",
      marginTop: "100px",
    },
    modal: {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      margin: "auto",
      width: 400,
      height: "fit-content",
      background: Colors.blackGrey,
      padding: "30px",
      position: "absolute",
    },
    addChannel: {
      marginTop: "101px",
      marginLeft: "75px",
    },
    verticalDivider: {
      height: "550px",
    },
    inputButtons: {
      color: Colors.black,
    },
    centerAlign: {
      textAlign: "center",
    },
    activityMargin: {},
    activityMargin1: {},
    activityMargin2: {},
    uploadimagebr: {
      borderRadius: "15px",
    },
    ul: {
      fontSize: fontSizes.mlxl,
    },
    topright: {
      position: "absolute",
      top: "8px",
      right: " 16px",
    },
    thumbnail: {
      width: "60px",
      height: "40px",
      borderRadius: "5px",
    },
    crossImage: {
      width: "15px",
      height: "15px",
      background: Colors.grey,
      borderRadius: "15px",
      padding: "3px",
    },
    uploadImage: {
      position: "absolute",
      top: "0px",
      left: "50px",
      zIndex: 0,
      color: "white",
    },
    relativePosition: {
      position: "relative",
    },
    uploadVideo: {
      position: "relative",
      objectFit: "fill",
      component: "img",
      height: "150px",
    },
    videoRecording: {
      height: "200px",
      width: "300px",
    },
    recordTime: {
      position: "absolute",
      top: "7px",
      left: 240,
      width: "45px",
      height: "25px",
      bgcolor: "rgba(0, 0, 0, 0.54)",
      background: Colors.transparent,
      color: "white",
      padding: "5px",
      backdropFilter: "blur(90px)",
      borderRadius: "13px",
      textAlign: "center",
    },
    cardAction: {
      backgroundColor: Colors.lightGrey5,
      height: "50px",
    },
    pl0: {
      paddingLeft: "0px !important",
    },
    pr0: {
      paddingRight: "0px !important",
    },
    pointer: {
      cursor: "pointer",
    },
    textLeft: {
      textAlign: "left",
    },
    textRight: {
      textAlign: "right",
    },
  }
})

export const ButtonStyle = (theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        textTransform: "none",
        // marginTop: theme.spacing(1),
        background: Colors.btnBg,
        // border: `${theme.spacing(0.2)} solid ${theme.palette.primary.main}`,
        // borderRadius: theme.shape.borderRadius,
        // padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
        // height: theme.spacing(5),
        "&:hover": {
          background: Colors.white,
          // color: theme.palette.primary.main,
          // borderColor: theme.palette.primary.main,
        },
        "&:disabled": {
          color: theme.palette.secondary.main,
          cursor: "not-allowed",
          pointerEvents: "unset!important",
        },
      },
    },
  }
}

export const DividerStyle = (theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        color: theme.palette.secondary.main,
        borderColor: `${Colors.dividerColor} !important`,
        // /        marginBottom: `${theme.spacing(1)} 0px`,
      },
    },
  }
}

export const InputStyle = (theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        height: dimensions.normalHeight,
        // marginTop: theme.spacing(2),
        background: Colors.darkBlueBg,
        color: theme.palette.secondary.main,
        textDecorationColor: theme.palette.secondary.main,
      },
    },
  }
}

export const OutlinedInputStyle = (theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        height: dimensions.normalHeight,
        color: theme.palette.secondary.main,
        background: Colors.darkBlueBg,
        fontSize: fontSizes.sm,
        textDecorationColor: theme.palette.secondary.main,
        borderColor: Colors.lightBlue,
        "&:focused": {
          borderColor:
            theme.palette.mode === "light"
              ? Colors.lightBlue
              : Colors.lightBlue,
          // border: `${theme.spacing(0.125)} solid`,
        },
      },
    },
  }
}

export const TitleStyle = (theme: Theme) => {
  return {
    fontSize: fontSizes.xl,
    color: theme.palette.secondary.main,
    fontWeight: "bold",
  }
}

export const SubTitleStyle = (theme: Theme) => {
  return {
    fontSize: fontSizes.sm,
    color: theme.palette.secondary.main,
  }
}

export const ParagraphStyle = (theme: Theme) => {
  return {
    fontSize: fontSizes.xsm,
    color: theme.palette.secondary.main,
  }
}

export const PaperStyle = (theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        background: "#4787FE",
        // marginTop: theme.spacing(2),
      },
    },
  }
}

export const InputLabelStyle = (theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        color: theme.palette.secondary.main,
      },
    },
  }
}
